const scaleEmValue = (value, multiplier) => {
  const numberValue = Number.parseFloat(String(value || '0'));
  if (!Number.isFinite(numberValue)) return value;
  return `${(numberValue * multiplier).toFixed(3).replace(/0+$/, '').replace(/\.$/, '')}em`;
};

const getDailyLettersFitConfig = (letters) => {
  const normalized = String(letters || '').toUpperCase().replace(/[^A-Z]/g, '');
  const count = normalized.length;
  const widthUnits = normalized.split('').reduce((total, letter) => {
    if ('MW'.includes(letter)) return total + 1.42;
    if ('QOGCBDUN'.includes(letter)) return total + 1.18;
    if ('SHAKRVX'.includes(letter)) return total + 1.06;
    if ('IJLFT'.includes(letter)) return total + 0.72;
    return total + 0.94;
  }, 0);
  const widthPressure = widthUnits + (Math.max(0, count - 4) * 0.42);

  if (widthPressure >= 8.2) return { count, widthUnits, compressor: 0.74, maxFontSize: 34, minFontSize: 19, letterSpacing: '0.008em', wordSpacing: '0.08em' };
  if (widthPressure >= 7.2) return { count, widthUnits, compressor: 0.66, maxFontSize: 40, minFontSize: 22, letterSpacing: '0.014em', wordSpacing: '0.12em' };
  if (widthPressure >= 6.2) return { count, widthUnits, compressor: 0.58, maxFontSize: 46, minFontSize: 25, letterSpacing: '0.022em', wordSpacing: '0.16em' };
  if (count >= 6) return { count, widthUnits, compressor: 0.54, maxFontSize: 50, minFontSize: 28, letterSpacing: '0.034em', wordSpacing: '0.18em' };
  if (count === 5) return { count, widthUnits, compressor: 0.5, maxFontSize: 56, minFontSize: 31, letterSpacing: '0.046em', wordSpacing: '0.22em' };
  return { count, widthUnits, compressor: 0.46, maxFontSize: 64, minFontSize: 35, letterSpacing: '0.065em', wordSpacing: '0.28em' };
};

export const getDailyLettersFitMobile = (letters) => {
  const base = getDailyLettersFitConfig(letters);
  const isWideOrLong = base.count >= 6 || base.widthUnits >= 5.6;
  const maxCap = base.count <= 2 ? 72 : base.count <= 4 ? 62 : base.count === 5 ? 58 : 54;
  return {
    ...base,
    compressor: isWideOrLong
      ? Math.max(0.5, Number(base.compressor) - 0.05)
      : Math.max(0.4, Number(base.compressor) - 0.07),
    maxFontSize: Math.min(maxCap, Math.round(Number(base.maxFontSize) * (isWideOrLong ? 0.98 : 1.08))),
    minFontSize: Math.min(30, Math.round(Number(base.minFontSize) * 0.96)),
    letterSpacing: scaleEmValue(base.letterSpacing, isWideOrLong ? 0.72 : 0.88),
    wordSpacing: scaleEmValue(base.wordSpacing, isWideOrLong ? 0.76 : 0.92),
  };
};
